<template>
  <div>
    <b-message
      v-if="
        bookingResponse.bookingInformation.selectedPaymentMethod
          .paymentOptionName == 'CASH' ||
          bookingResponse.bookingInformation.selectedPaymentMethod
            .paymentOptionName == 'EFT'
      "
      type="is-warning"
      id="confirmation"
    >
      <h1>Thank you for booking your flight with us.</h1>
      <p>
        <b style="color: red;">This confirmation is not valid for travel!</b>
      </p>
      <p>
        <b>Flightsite booking reference: </b> {{ bookingResponse.bookingInformation.bookingReferenceNo }}
      </p>
      <p class="width-100" v-if="pnpReferenceNumber">
        <b>PnP payment reference: </b> {{ pnpReferenceNumber }}
      </p>
      <p>
        <b>Payment due by: </b>
        <!-- bookingResponse.bookingInformation.lastPayDate -->
        {{lastPayDate}}
      </p>
      <p
        v-if="
          bookingResponse.bookingInformation.selectedPaymentMethod
            .paymentOptionName == 'EFT'
        "
      >
        <b>Bank Id: </b>
        {{ bookingResponse.bookingInformation.selectedPaymentMethod.bankId }}
        <br />
        <b>Account Number: </b>
        {{ bookingResponse.bookingInformation.selectedPaymentMethod.accountNo }}
        <br />
        <b>Branch Number: </b>
        {{ bookingResponse.bookingInformation.selectedPaymentMethod.branchNo }}
        <br />
        <b>Booking Reference: </b>
        {{ bookingResponse.bookingInformation.bookingReferenceNo }} <br />
        <b>Total due: </b> R{{
          Math.ceil(bookingResponse.fareBreakdown.totalAmount)
        }}
      </p>
      <p>
        Once we have processed your payment we will send you your e-ticket in a
        separate email. For flights departing in more than one day this may take
        up to 24 hours. Please take a minute to verify all your details,
        especially the passenger names and travel dates. Once your ticket has
        been issued airline penalties may apply to make any changes or process
        any cancellations.
      </p>
    </b-message>
    <b-message v-else type="is-success" id="confirmation">
      <h1>Your booking was successful!</h1>
      <p>
        <b>Your Flightsite booking reference:</b>
        <br />
        {{ bookingResponse.bookingInformation.bookingReferenceNo }}
      </p>
    </b-message>
    <b-message
      type="is-primary"
      class="no-margin-bottom no-border content-sized"
    >
      <div class="summary-list">
        <div>
          <h3>Price breakdown</h3>
          Airfare per adult:
          <b
            >R{{
              Math.ceil(
                priceResponse.fareBreakdown.adults.baseFare /
                  priceResponse.travellers.adults
              )
            }}</b
          >
          <span v-if="priceResponse.fareBreakdown.children">
            <br />Airfare per child:
            <b
              >R{{
                Math.ceil(
                  priceResponse.fareBreakdown.children.baseFare /
                    priceResponse.travellers.children
                )
              }}</b
            >
          </span>
          <span v-if="priceResponse.fareBreakdown.infants">
            <br />Airfare per infant:
            <b
              >R{{
                Math.ceil(
                  priceResponse.fareBreakdown.infants.baseFare /
                    priceResponse.travellers.infants
                )
              }}</b
            >
          </span>
          <span v-if="paymentCharge > 0">
            <br />Payment option fee:
            <b>R{{ Math.ceil(paymentCharge) }}</b>
          </span>
          <span v-if="baggageCost > 0">
            <br />Total baggage cost:
            <b>R{{ Math.ceil(baggageCost) }}</b>
          </span>
          <br />Total airport taxes:
          <b>R{{ Math.ceil(priceResponse.fareBreakdown.taxAmount) }}</b>
          <span v-if="productsCost > 0">
            <br />Total extras:
            <b>R{{ Math.ceil(productsCost) }}</b>
          </span>
          <br />
          Total price:
          <b
            >R{{
              Math.ceil(
                bookingResponse.fareBreakdown.totalAmount
              )
            }}</b
          >
        </div>

        <div>
          <h3>Payer</h3>
          <b class="no-margin">Name:</b>
          {{ payer.title }} {{ payer.firstName }} {{ payer.lastName }}
          <br />
          <b class="no-margin">Email:</b>
          {{ payer.email }}
          <br />
          <b class="no-margin">Contact No:</b>
          {{ payer.mobileNumber }}
        </div>

        <div
          v-for="passenger in passengers.adults
            .concat(passengers.children)
            .concat(passengers.infants)"
          :key="`passenger-${passenger.index}`"
        >
          <h3>Passengers</h3>
          <b class="no-margin">Name:</b>
          {{ passenger.title }} {{ passenger.firstName }}
            {{ passenger.middleName }} {{ passenger.lastName }}
          <br />
          <b class="no-margin">Dob:</b>
          {{ passenger.dob.day }}/{{ passenger.dob.month }}/{{
            passenger.dob.year
          }}
          <span v-if="passenger.documentNumber">
            <br />
            <b class="no-margin">Document Number:</b>
            {{ passenger.documentNumber }}
          </span>
        </div>
      </div>

      <div class="itinerary-breakdown">
        <div class="trip-split">
          <ConfirmationFlight
            :flight-details="selectedFlights.outbound"
          ></ConfirmationFlight>
          <div class="mobile-width-100" v-if="flags.isDomesticReturn">
            <ConfirmationFlight
              :flight-details="selectedFlights.return"
            ></ConfirmationFlight>
          </div>
        </div>
        <div
          type="is-primary"
          class="review-content"
          v-for="flight in allFlights"
          :key="flight.index"
        >
          <b>Flight:</b>
          {{ searchResults.airlineNames[flight.airlineCode] }}
          {{ flight.flightNumber }}
          <span class="dulled-text" v-if="flight.opAirlineCode"
            >- operated by {{ flight.opAirlineCode.toLowerCase() }}</span
          >
          <br />
          <b>Depart:</b>
          {{ formatDate(flight.departureDateTime) }} from ({{
            flight.origCode
          }})
          {{ determineLocationFromCode(flight.origCode).airport }}
          <br />
          <b>Arrive:</b>
          {{ formatDate(flight.arrivalDateTime) }} at ({{ flight.destCode }})
          {{ determineLocationFromCode(flight.destCode).airport }},
          <br />
          <b>Cabin:</b>
          {{ flight.cabinClass.toLowerCase() }}
        </div>
      </div>

      <div
        v-for="(leg, index) in selectedFlights.outbound.odoList"
        :key="'leg-' + index"
      >
        <b class="flight">
          Baggage {{ leg.segments[0].origCode }} to
          {{ leg.segments[leg.segments.length - 1].destCode }}:
        </b>
        <br />
        <span
          v-for="(bag, index) in leg.segments[0].baggage"
          :key="'bag-' + index"
        >
          <span
            v-if="
              bag.type == 'CHECKED' &&
                !bag.name.includes('No') &&
                !bag.name.includes('+')
            "
          >
            {{ bag.name }} checked baggage
          </span>
          <span v-else-if="bag.name.includes('+')">
            {{ bag.name }} available at passenger details step
          </span>
          <span v-else-if="bag.name.includes('No')">
            No checked baggage
          </span>
          <span v-else>
            {{ bag.name }}
          </span>
          <br />
        </span>
      </div>
      <div v-if="!isEmpty(selectedFlights.return)">
        <div
          v-for="(leg, index) in selectedFlights.return.odoList"
          :key="'leg-' + index"
        >
          <b class="flight">
            Baggage {{ leg.segments[0].origCode }} to
            {{ leg.segments[leg.segments.length - 1].destCode }}:
          </b>
          <br />
          <span
            v-for="(bag, index) in leg.segments[0].baggage"
            :key="'bag-' + index"
          >
            <span
              v-if="
                bag.type == 'CHECKED' &&
                  !bag.name.includes('No') &&
                  !bag.name.includes('+')
              "
            >
              {{ bag.name }} checked baggage
            </span>
            <span v-else-if="bag.name.includes('+')">
              {{ bag.name }} available at passenger details step
            </span>
            <span v-else-if="bag.name.includes('No')">
              No checked baggage
            </span>
            <span v-else>
              {{ bag.name }}
            </span>
            <br />
          </span>
        </div>
      </div>
    </b-message>
  </div>
</template>

<script>
import ConfirmationFlight from "@/components/ConfirmationFlight.vue";
import Api from "@/services/Api.service.js";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "confirmation",
  computed: {
    ...mapState([
      "selectedFlights",
      "searchResults",
      "priceResponse",
      "bookingResponse",
      "flags",
      "payer",
      "passengers",
      "urlSearchParameters",
      "searchParameters",
      "extraDetails",
      "baggageCost",
      "products",
      "paymentCharge",
      "pnpReferenceNumber"
    ]),
    paymentType() {
      if (
        this.bookingResponse.bookingInformation.selectedPaymentMethod
          .paymentOptionName == "CASH"
      ) {
        return "PNP";
      } else if (
        this.bookingResponse.bookingInformation.selectedPaymentMethod
          .paymentOptionName == "EFT"
      ) {
        return "EFT";
      } else {
        return "CARD";
      }
    },
    allFlights() {
      let flights = [];
      for (let itinerary of this.priceResponse.itineraries) {
        for (let leg of itinerary.odoList) {
          for (let segment of leg.segments) {
            segment.specialAttributes = itinerary.specialServiceAttributes;
            flights.push(segment);
          }
        }
      }
      return flights;
    },
    productsCost() {
      let result = 0;
      this.products.forEach(selected => {
        if (selected.selectedValue) {
          result += this.priceResponse.products.find(e => e.id == selected.id)
            .amount;
        }
      });
      return result;
    },
    lastPayDate() {
      return moment().hour(23).minute(0).second(0).format("H:mm MMMM Do");
    }
  },
  methods: {
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    formatDate(date) {
      return moment(date).format("H:mm MMMM Do");
    },
    determineLocationFromCode(code) {
      if (this.searchResults) {
        return this.searchResults.airportInfos.find(e => {
          return e.iataCode == code;
        });
      }
      return undefined;
    },
  },
  data: function() {
    return {
      isTrue: true
    };
  },
  components: {
    ConfirmationFlight
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#confirmation {
  max-width: 720px;
  margin: 1rem auto;
  margin-bottom: 0.67em;
  border-radius: 8px;
  text-align: left;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  p + p {
    margin-top: 0.75em;
  }
}

.review-content {
  margin-bottom: 1rem;
}

.trip-split {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
}

.no-margin {
  margin: 0;
}

.message-body {
  padding: 1em !important;
}

.bold {
  font-weight: bold;
}

.itinerary-breakdown {
  max-width: 720px;
  margin: 1rem auto;
  margin-bottom: 0.67em;
}

.mobile-width-100 {
  width: 100%;
}

.width-100 {
  width: 100%;
}

.content-sized {
  max-width: 720px;
  margin: 0.75em auto !important;
}

.summary-list {
  max-width: 720px;
  border-radius: 8px;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  article + article {
    margin-left: 0.75em;
  }
}

hr {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.details-divider {
  width: 100%;
  border-bottom: 2px dashed $grey;
}

h1 {
  font-weight: bold;
  font-size: 1.1em;
}

@media (min-width: 781px) {
  h1 {
    font-size: 1.4em;
  }

  .mobile-width-100 {
    width: 100%;
  }

  #confirmation {
    margin: 2rem auto 0.75em auto;
  }
}
</style>

<style lang="scss">
@import "@/assets/styles/settings.scss";
.message.is-primary .message-body {
  border-color: $primary-color !important;
  color: #04333d;
}
</style>
